import React, { useContext } from 'react';

import AbTestBranch from 'components/ab-test-branch/ab-test-branch';
import { Variation } from 'components/ab-test/ab-test';
import Footer from 'components/footer/footer';
import FooterNew from 'components/footer/footer-new';
import LayoutContext from 'contexts/layoutContext';
import { Drupal_Node } from 'generated/graphql';
import { useMenuDefaultFooter } from 'hooks/use-menu';
import { MenuLink } from 'types/types';

interface Props {
  padFooter?: boolean;
  entityTranslations?: Drupal_Node[];
  menu: MenuLink[];
}

const FooterSwapAbTest = ({ menu, padFooter, entityTranslations }: Props) => {
  const {
    language: { langPrefix }
  } = useContext(LayoutContext);

  const defaultFooterMenu = useMenuDefaultFooter(langPrefix);

  return (
    <>
      <AbTestBranch branch={Variation.A}>
        <Footer
          entityTranslations={entityTranslations}
          menu={menu}
          padFooter={padFooter}
        />
      </AbTestBranch>
      <AbTestBranch branch={Variation.B}>
        <FooterNew
          entityTranslations={entityTranslations}
          menu={menu || defaultFooterMenu}
          padFooter={padFooter}
        />
      </AbTestBranch>
    </>
  );
};

export default FooterSwapAbTest;
